import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from "@/store";
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.custom.js";
import upLoad from '@/assets/img/upload_photo3.jpg';
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "refundConfirmation",
  components: {
    MainLayout,
    Loading,
    flatPickr,
    Select2Multiple
  },

  data() {
    return {
      refundData: {
        student_name: '',
        academic_year: '',
        grade_name: '',
        class_name: '',
        receiver: '',
        refund_details: [],
        payment_method_id: '',
        payment_screenshot: null,
        remark: '',
        payment_plan: '',
      },
      campusId: store.state.user.campus_id,
      isLoading: false,
      title: '',
      currency_txt: '',
      currentActiveTermId: '',
      paymentMethodArr: null,
      refundDate: new Date().toISOString().split('T')[0],
      submitted: false,
      TRANSACTION_CATEGORY: CONFIG.TRANSACTION_CATEGORY,
      TRANSACTION_TYPE: CONFIG.TRANSACTION_TYPE,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      PAYMENT_PLANS: CONFIG.PAYMENT_PLAN_IDS,
      hasRefundHistory: false,
      ssImage: '',
      upLoad,
      error: {},
      STATUS_DISPLAY: CONFIG.TUITION_PAYMENT_STATUS.STATUS_DISPLAY,
    };
  },

  validations: {
    refundData: {
      payment_method_id: { required },
      receiver: { required, maxLength: maxLength(100) },
      remark: {  maxLength: maxLength(1000) },
    },
    refundDate: { required },
  },

  computed: {
    totalRefundAmount() {
      const total = this.refundData.refund_details.reduce((sum, item) => {
        return sum + Number(item.calculated_amount || 0);
      }, 0);
      return total.toFixed(2);
    },
    tuitionPaymentId() {
      return this.$route.params.tuitionPaymentId;
    }
  },

  watch: {
    refundDate: function(newDate, oldDate) {
      if (oldDate && newDate && newDate !== oldDate) {
        this.getDetail();
      }
    }
  },

  methods: {
    getStudentData() {
      axios.get(`student/statement/detail/${this.tuitionPaymentId}`)
        .then(response => {
          const studentInfo = response.data.statement_info;
          if (studentInfo) {
            this.status = studentInfo.status || '';
            if (this.status != this.STATUS_DISPLAY) {
              this.$notification.error("Refund not allowed for this status", {
                timer: 3,
                position: "bottomCenter"
              });
              this.goBack();
              return;
            }

            const payments = studentInfo.student_payments || [];
            const allFullyPaid = payments.every(p => p.payment_history_status === CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID);
            if (!allFullyPaid) {
              this.$notification.error("Refund not allowed. All payments must be fully paid.", {
                timer: 3,
                position: "bottomCenter"
              });
              this.goBack();
              return;
            }
            this.refundData.student_name = studentInfo.student_name || '';
            this.refundData.academic_year = studentInfo.current_academic_period || '';
            this.refundData.grade_name = studentInfo.grade_name || '';
            this.refundData.class_name = studentInfo.current_class_name || '';
            this.refundData.receiver = studentInfo.guardian1_name || '';
            this.refundData.payment_plan = studentInfo.payment_plan || '';
          }
        })
        .catch(error => {
          console.error("Error fetching student data:", error);
        });
    },

    getDetail() {
      this.isLoading = true;
      axios.get(`enrollment/refund/detail/${this.tuitionPaymentId}`, {
        params: {
          campus_id: this.campusId,
          refund_date: this.refundDate
        }
      }).then(res => {
        if (res.data.status === 'success') {
          this.refundData.refund_details = res.data.data.refund_details || [];
          this.currency_txt = res.data.currency_txt || '';
          this.title = res.data.title || '';
          this.currentActiveTermId = res.data.term_id || '';
          this.hasRefundHistory = !!res.data.data.has_history;

          if (this.hasRefundHistory) {
            this.$notification.error("This statement is already refunded.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.goBack();
            return;
          }
        } else {
          this.$notification.error(res.data.message || "Refund not found", {
            timer: 3,
            position: "bottomCenter"
          });
          this.goBack();
          return;
        }
        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
        if (error.response && error.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          this.$notification.error("Failed to load refund details", {
            timer: 3,
            position: "bottomCenter"
          });
          console.error("Refund Detail API Error:", error);
        }
      });
    },

    goBack() {
      this.$router.push({ name: 'studentStatementDetail', params: { tuitionPaymentId: this.tuitionPaymentId } });
    },

    confirmRefund() {
      this.submitted = true;
      this.errors = {};

      if (this.totalRefundAmount <= 0) {
        this.$notification.error("Total refund amount must be greater than 0.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (!window.confirm(`Are you sure you want to refund this statement?`)) {
        return;
      }
      this.isLoading = true;
      const payload = {
        tuition_payment_id: this.tuitionPaymentId,
        refund_date: this.refundDate,
        payment_method_id: this.refundData.payment_method_id,
        remark: this.refundData.remark,
        refund_amount: this.totalRefundAmount,
        term_id: this.currentActiveTermId,
        receiver: this.refundData.receiver,
        type: this.TRANSACTION_TYPE.EXPENSE,
        payment_screenshot: this.ssImage,
        image_remove: !this.ssImage
      };
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      if (this.refundData.payment_screenshot instanceof File) {
        formData.append('payment_screenshot', this.refundData.payment_screenshot);
      }
      axios.post('enrollment/refund/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.$notification.success("Refund created successfully", { timer: 3, position: "bottomCenter" });
          this.goRefundList();
        } else {
          this.isLoading = false;
          this.$notification.error(res.data.message || "Failed to create refund", { timer: 3, position: "bottomCenter" });
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response?.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else if (error.response && error.response?.status === 422 && error.response?.data?.error) {
          this.$notification.error(error.response.data.error, {
            timer: 3,
            position: "bottomCenter",
          });
        } else if (error.response && error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          alert(Object.values(this.errors));
        } else {
          this.$notification.error("Failed to create refund data", { timer: 3, position: "bottomCenter" });
          console.error("Create Refund API Error:", error);
        }
      });
    },

    getPaymentMethod() {
      axios
      .get("getPaymentMethod")
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : res.data?.data || [];
        const formattedData = raw.map((item) => ({
          id: Number(item.id),
          text: item.text || item.payment_method || "",
        }));
        let $defaultSelectOption = [{ id: 0, text: "Select Payment Method" }];
        this.paymentMethodArr = $defaultSelectOption.concat(formattedData);
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          this.$store.commit("logout");
          window.location.replace("login");
        }
        this.isLoading = false;
      });
    },

    removeImg() {
      this.ssImage = '';
      document.getElementById('image').value = '';
    },

    imgUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      } else {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = (e) => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
              document.getElementById('image').value = '';
            } else {
              this.ssImage = e.target.result;
              document.getElementById('image').value = '';
            }
          }
          reader.readAsDataURL(files[0]);
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    goRefundList() {
      this.$router.push({
        name: 'refundHistoryList'
      });
    }
  },

  mounted() {
    this.getStudentData();
    this.getDetail();
    this.getPaymentMethod();
  },
};
